import React, { useEffect, useState } from "react";
import { ConfigurationDomainsView } from "../../views";
import { DomainService, LocalStorageService } from "../../../services/index";
import { ConfigurationDomainValidator } from "../../../validators";
import { useHistory } from "react-router-dom";
import { ModalUtil } from "../../pures";
import { useTranslation } from "react-i18next";

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
const domainService = new DomainService(url);

// La sesión se lee en cada handler (no en el scope del módulo): este módulo se
// importa de forma eager desde routes/index.js, antes de que exista el login.
const getToken = () => localStorageService.getLocalStorageItem("token")?.idToken
const modalUtil = new ModalUtil()

const ConfigurationDomainsAction = () => {
  const history = useHistory()
  const { t } = useTranslation();
  const validator = ConfigurationDomainValidator(t);

  const [loading, setLoading] = useState(true)

  const [domains, setDomains] = useState([])
  const [selectedDomain, setSelectedDomain] = useState(null)
  const [action, setAction] = useState(null)
  const [showDialogDeleteRequest, setShowDialogDeleteRequest] = useState(false)

  const toggleDialogDeleteDomain = (show) => {
    setShowDialogDeleteRequest(show)
  }

  const getDomains = async () => {
    try {
      setLoading(true)
      setAction(null)
      const domains = await domainService.getDomains(getToken());
      setDomains(domains);
      setLoading(false)
    } catch (err) {
      modalUtil.showModal('error', 'Error cargando dominios', 'Error getDomains', () => history.push('/'))
    }
  }

  const deleteDomain = async () => {
    try {
      setShowDialogDeleteRequest(false)
      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      let response = await domainService.deleteDomain(
        selectedDomain.id,
        selectedDomain.clientId,
        getToken()
      );

      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.domain.action.deleteDomainSuccess"), t("modal.pure.title.success"))
        getDomains()
        setSelectedDomain(null)
        return;
      } else if (response.statusCode === -3) {
        modalUtil.showModal('error', t("configuration.domain.action.domainSignerDeleteError"), t("modal.pure.title.error"))
      } else if (response.statusCode === -4) {
        modalUtil.showModal('error', t("configuration.domain.action.domainDeleteError"), t("modal.pure.title.error"))
      } else {
        throw new Error(t("configuration.domain.action.delete-domain"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  };

  const createDomain = async (data) => {
    try {
      let { name, description } = data
      let domainValid = validator.domainValidator(name);

      if (domainValid !== "") {
        modalUtil.showModal('error', t("configuration.domain.action.messageErrorCurrentDomain"), t("modal.pure.title.error"))
        return;
      }

      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
      const response = await domainService.createDomain(name, description, getToken());

      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.domain.action.createDomainSuccess"), t("modal.pure.title.success"))
        getDomains()
        return
      } else if (response.statusCode === -2) {
        modalUtil.showModal('error', t("configuration.domain.action.domainExists"), t("modal.pure.title.error"))
      } else {
        throw new Error(t("configuration.domain.action.general.error"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  }

  const editDomain = async (data) => {
    const { id, clientId, name, description } = data

    try {
      const domainValid = validator.domainValidator(name);
      if (domainValid !== "") {
        modalUtil.showModal('error', t("configuration.domain.action.messageErrorCurrentDomain"), t("modal.pure.title.error"))
        return;
      }

      modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))

      const response = await domainService.updateDomain(id, clientId, name, description, getToken());

      if (response.statusCode === 200) {
        await modalUtil.showModal('success', t("configuration.domain.action.updateDomainSuccess"), t("modal.pure.title.success"))
        setSelectedDomain(null)
        getDomains()
        return;
      } else if (response.statusCode === -2) {
        modalUtil.showModal('error', t("configuration.domain.action.updateDomainError"), t("modal.pure.title.error"))
      } else if (response.statusCode === -3) {
        modalUtil.showModal('error', t("configuration.domain.action.domainSignerUpdateError"), t("modal.pure.title.error"))
      } else {
        throw new Error(t("configuration.domain.action.general.error.edit"))
      }
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  }

  useEffect(() => {
    getDomains();
  }, [])

  return (
    <ConfigurationDomainsView
      loading={loading}
      domains={domains}
      setData={setDomains}
      selectedDomain={selectedDomain}
      setSelectedDomain={setSelectedDomain}

      action={action}
      setAction={setAction}

      showDialogDeleteRequest={showDialogDeleteRequest}
      toggleDialogDeleteDomain={toggleDialogDeleteDomain}

      deleteDomain={deleteDomain}
      createDomain={createDomain}
      editDomain={editDomain}
    />
  )
}


export { ConfigurationDomainsAction as default };
